import React, {useEffect, useState} from 'react'
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import Header from "../../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../../Images/no-data-found.webp";
import Moment from "moment/moment";

const RcStatusRemark = ({
                         history,
                         match,
                            rcCaseByIdRequest,
                            rcCaseByIdResponse
                    }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [userId, setUserId] = useState('');

    useEffect(() => {
        (async () => {
            setUserId(window.localStorage.user_id);
            setIsLoading(true)
            await rcCaseByIdRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Rc Remark'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    {/*CARD START*/}
                                    {rcCaseByIdResponse?.data && rcCaseByIdResponse?.data?.remarks && rcCaseByIdResponse?.data?.remarks.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    <div className="row list-view">
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-id-card" style={{color: 'black'}}></i>&nbsp;&nbsp;State
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                >{val?.updated_on_state}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-car-side" style={{color: '#6b4ebe'}}></i>&nbsp;&nbsp;Remark
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.value}>{val?.value}</span>
                                                                            </div>
                                                                        </div>


                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Created
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.timestamp).format('DD-MM-YYYY')}</div>
                                                                        </div>

                                                                    </div>
                                                                    <hr/>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                        })}

                                    {rcCaseByIdResponse && rcCaseByIdResponse?.length === 0  &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" style={{maxWidth: "100%"}} alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {/* section ends */}
        </>
    )
}

export default RcStatusRemark